import CodeBlock from '../CodeBlock';

export default function DocsHero() {
  return (
    <section data-docs-section="hero" className="text-left mb-16">
      <div className="flex items-center gap-3 mb-4">
        <h1 className="text-4xl font-bold text-white">PropAlgos SDK</h1>
        <span className="text-xs font-mono px-2.5 py-1 rounded-full bg-sky-500/10 text-sky-400 border border-sky-500/20">
          v0.4.0
        </span>
      </div>
      <p className="text-lg text-gray-400 mb-6 max-w-2xl">
        A Python toolkit for quantitative research — data ingestion, signal
        generation, vectorized backtesting, and Plotly visualization on GPU
        cloud infrastructure.
      </p>
      <CodeBlock
        code="pip install propalgos"
        language="bash"
      />
      <CodeBlock
        code={`import propalgos as pa

# Check GPU status
pa.gpu_status()

# Discover available datasets
pa.data.list_datasets()

# Fetch prices, generate signal, backtest, visualize
prices = pa.data.prices("SPY", start="2020-01-01")
signal = pa.signals.sma_cross(prices, fast=20, slow=100)
result = pa.backtest.run(prices, signal)
pa.viz.tearsheet(result)`}
        filename="quickstart.py"
      />
    </section>
  );
}
